import { useState } from 'react';
import { api } from '../../../api/client.js';

// Freeform key/value attributes (spec §15) — no fixed "calories/spice
// level/..." columns, the restaurant defines whatever it needs.
export function AttributesEditor({ menuId, categoryId, itemId, attributes, onChanged }) {
  const [label, setLabel] = useState('');
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [removingId, setRemovingId] = useState(null);
  const base = `/api/menus/${menuId}/categories/${categoryId}/items/${itemId}/attributes`;

  async function handleAdd(event) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post(base, { label: label.trim(), value: value.trim() });
      setLabel('');
      setValue('');
      onChanged();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  async function handleRemove(attributeId) {
    setError(null);
    setRemovingId(attributeId);
    try {
      await api.delete(`${base}/${attributeId}`);
      onChanged();
    } catch (err) {
      setError(err.message);
    } finally {
      setRemovingId(null);
    }
  }

  return (
    <div className="extras-editor">
      <div className="extras-editor__heading">
        <div><h4>Dietary & item details</h4><p>Short labels guests can scan, such as “Spice level: Medium”.</p></div>
      </div>
      {error && <p className="field-error">{error}</p>}
      {attributes.length > 0 && (
        <div className="attribute-chips">
          {attributes.map((attr) => (
            <div key={attr.id} className="attribute-chip">
              <span><strong>{attr.label}:</strong> {attr.value}</span>
              <button type="button" onClick={() => handleRemove(attr.id)} disabled={removingId === attr.id} aria-label={`Remove ${attr.label}`}>
                {removingId === attr.id ? '…' : '×'}
              </button>
            </div>
          ))}
        </div>
      )}
      <form onSubmit={handleAdd} className="attribute-add-form">
        <input
          type="text"
          aria-label="Detail name"
          placeholder="Detail, e.g. Spice level"
          required
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <input
          type="text"
          aria-label="Detail value"
          placeholder="Value, e.g. Medium"
          required
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button type="submit" className="btn btn-sm" disabled={submitting}>{submitting ? 'Adding…' : 'Add detail'}</button>
      </form>
    </div>
  );
}
